import { __decorate, __metadata } from 'tslib';
import { forwardRef, Input, Component, EventEmitter, Output, Injectable, ViewChild, NgModule, ElementRef, HostListener, Directive, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, FormsModule as FormsModule$1, ReactiveFormsModule } from '@angular/forms';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { isNullOrUndefined } from 'util';
import { UIModule } from '@pwc/ui';
import { NgbDateParserFormatter, NgbInputDatepicker, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { piCalendarSmall, PwcIconsLibrary, PwcIconsModule, piClear } from '@pwc/icons';
import { DateUtils, CommonModule as CommonModule$1 } from '@pwc/common';
import { I18nModule } from '@pwc/i18n';
import { TranslateModule } from '@ngx-translate/core';
import { NgxCurrencyModule } from 'ngx-currency';
import { InputMaskModule } from 'racoon-mask-raw';
import { NgSelectModule } from '@ng-select/ng-select';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@fortawesome/angular-fontawesome';
import * as ɵngcc4 from 'ngx-currency';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc6 from '@pwc/icons';
import * as ɵngcc7 from 'racoon-mask-raw';
import * as ɵngcc8 from '@ngx-translate/core';
import * as ɵngcc9 from '@ng-select/ng-select';

function FormInputComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function FormInputComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.invalidFeedback);
} }
function EmailInputComponent_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fa-icon", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("icon", ctx_r0.faCircleNotch)("spin", true);
} }
const _c0 = function (a0) { return { "has-label": a0 }; };
function SearchInputComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 3);
    ɵngcc0.ɵɵlistener("click", function SearchInputComponent_i_2_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.value = ""; });
    ɵngcc0.ɵɵtext(1, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = ["datePicker"];
function FiltersComponent_div_0_ng_container_10_div_1_div_4_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function FiltersComponent_div_0_ng_container_10_div_1_div_4_input_1_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const field_r2 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return (ctx_r8.values[field_r2.id] = $event); })("ngModelChange", function FiltersComponent_div_0_ng_container_10_div_1_div_4_input_1_Template_input_ngModelChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(5); return ctx_r11.onChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", field_r2.id)("name", field_r2.id)("ngModel", ctx_r6.values[field_r2.id]);
} }
function FiltersComponent_div_0_ng_container_10_div_1_div_4_pwc_date_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "pwc-date-input", 19);
    ɵngcc0.ɵɵlistener("dateChange", function FiltersComponent_div_0_ng_container_10_div_1_div_4_pwc_date_input_2_Template_pwc_date_input_dateChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const field_r2 = ɵngcc0.ɵɵnextContext(3).$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return (ctx_r13.values[field_r2.id] = $event); })("dateChange", function FiltersComponent_div_0_ng_container_10_div_1_div_4_pwc_date_input_2_Template_pwc_date_input_dateChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(5); return ctx_r16.onChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", field_r2.id)("date", ctx_r7.values[field_r2.id]);
} }
function FiltersComponent_div_0_ng_container_10_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, FiltersComponent_div_0_ng_container_10_div_1_div_4_input_1_Template, 1, 3, "input", 16);
    ɵngcc0.ɵɵtemplate(2, FiltersComponent_div_0_ng_container_10_div_1_div_4_pwc_date_input_2_Template, 1, 2, "pwc-date-input", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r2.type === ctx_r4.FilterType.TEXT);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r2.type === ctx_r4.FilterType.DATE);
} }
function FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_ng_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ng-option", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r20 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", option_r20.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 2, option_r20.label), " ");
} }
function FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ng-select", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_Template_ng_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const field_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return (ctx_r21.values[field_r2.id] = $event); })("change", function FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_Template_ng_select_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const field_r2 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.onOptionChange(field_r2); })("remove", function FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_Template_ng_select_remove_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r26 = ɵngcc0.ɵɵnextContext(4); return ctx_r26.onChange(); })("clear", function FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_Template_ng_select_clear_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r27 = ɵngcc0.ɵɵnextContext(4); return ctx_r27.onChange(); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵtemplate(2, FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_ng_option_2_Template, 3, 4, "ng-option", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(1, 8, "generic.select-value"));
    ɵngcc0.ɵɵproperty("id", field_r2.id)("name", field_r2.id)("ngModel", ctx_r5.values[field_r2.id])("searchable", true)("clearable", true)("multiple", field_r2.type === ctx_r5.FilterType.MULTISELECT);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", field_r2.options);
} }
function FiltersComponent_div_0_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "label", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, FiltersComponent_div_0_ng_container_10_div_1_div_4_Template, 3, 2, "div", 13);
    ɵngcc0.ɵɵtemplate(5, FiltersComponent_div_0_ng_container_10_div_1_ng_select_5_Template, 3, 10, "ng-select", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", field_r2.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 4, field_r2.label), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.isSelect(field_r2.type));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isSelect(field_r2.type));
} }
function FiltersComponent_div_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FiltersComponent_div_0_ng_container_10_div_1_Template, 6, 6, "div", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.isVisible(field_r2));
} }
function FiltersComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "h5", 3);
    ɵngcc0.ɵɵelementStart(3, "span", 4);
    ɵngcc0.ɵɵtext(4, "generic.filters.label");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 5);
    ɵngcc0.ɵɵlistener("click", function FiltersComponent_div_0_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.clear.emit(); });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelement(7, "pwc-icon", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "div", 8);
    ɵngcc0.ɵɵtemplate(10, FiltersComponent_div_0_ng_container_10_Template, 2, 1, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngbTooltip", ɵngcc0.ɵɵpipeBind1(6, 2, "generic.filters.clear"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.config);
} }
const _c2 = ["*"];
class AbstractValueAccessor {
    constructor() {
        this.accessorDisabled = false;
        this.onChange = (_) => {
        };
        this.onTouched = () => {
        };
    }
    get value() {
        return this.accessorValue;
    }
    set value(v) {
        if (v !== this.accessorValue) {
            this.accessorValue = v;
            this.onChange(v);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.accessorDisabled = isDisabled;
    }
    writeValue(obj) {
        // NOTE: Customize logic if you want to trigger onChange only on user intervention.
        this.value = obj;
    }
}
AbstractValueAccessor.ɵfac = function AbstractValueAccessor_Factory(t) { return new (t || AbstractValueAccessor)(); };
AbstractValueAccessor.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractValueAccessor });
function MakeProvider(type) {
    return {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => type),
        multi: true
    };
}

var FormInputComponent_1;
let FormInputComponent = FormInputComponent_1 = class FormInputComponent extends AbstractValueAccessor {
    constructor() {
        super(...arguments);
        this.type = 'text';
        this.placeholder = '';
        this.disabled = false;
        this.isInvalid = false;
    }
    ngOnInit() {
        if (!this.id != null && this.name == null) {
            this.name = this.id;
        }
    }
    get classes() {
        let classes = {
            'is-invalid': this.isInvalid
        };
        if (this.cssClass == null) {
            return classes;
        }
        if (typeof this.cssClass === 'string') {
            classes[this.cssClass] = true;
        }
        else if (typeof this.cssClass === 'object') {
            classes = Object.assign(Object.assign({}, classes), this.cssClass);
        }
        else {
            // @ts-ignore
            for (const item of this.cssClass) {
                classes[item] = true;
            }
        }
        return classes;
    }
};
FormInputComponent.ɵfac = function FormInputComponent_Factory(t) { return ɵFormInputComponent_BaseFactory(t || FormInputComponent); };
FormInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FormInputComponent, selectors: [["form-input"]], inputs: { type: "type", placeholder: "placeholder", disabled: "disabled", isInvalid: "isInvalid", name: "name", id: "id", cssClass: "cssClass", label: "label", invalidFeedback: "invalidFeedback" }, features: [ɵngcc0.ɵɵProvidersFeature([MakeProvider(FormInputComponent_1)]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 9, consts: [[1, "form-group", "form-input-group"], ["class", "form-input-label", 4, "ngIf"], [1, "form-control", "form-input", 3, "type", "ngModel", "ngClass", "placeholder", "disabled", "id", "name", "ngModelChange"], ["class", "invalid-feedback", 4, "ngIf"], [1, "form-input-label"], [1, "invalid-feedback"]], template: function FormInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FormInputComponent_label_1_Template, 2, 1, "label", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function FormInputComponent_Template_input_ngModelChange_2_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, FormInputComponent_div_3_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("type", ctx.type)("ngModel", ctx.value)("ngClass", ctx.classes)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("id", ctx.id)("name", ctx.name);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidFeedback && ctx.isInvalid);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc1.NgClass], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], FormInputComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormInputComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormInputComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], FormInputComponent.prototype, "cssClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], FormInputComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormInputComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], FormInputComponent.prototype, "isInvalid", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], FormInputComponent.prototype, "invalidFeedback", void 0);

class ValidationUtils {
    static email(value) {
        if (ValidationUtils.isEmptyValue(value)) {
            return false;
        }
        return /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/.test(value);
    }
    static isEmptyValue(value) {
        return isNullOrUndefined(value) || !value.trim().length;
    }
}

var EmailInputComponent_1;
let EmailInputComponent = EmailInputComponent_1 = class EmailInputComponent extends AbstractValueAccessor {
    constructor() {
        super(...arguments);
        this.required = false;
        this.disabled = false;
        this.invalidFeedback = 'Inserisci un indirizzo email valido.';
        this.loading = false;
        this.faCircleNotch = faCircleNotch;
    }
    get isValid() {
        if (!this.required && ValidationUtils.isEmptyValue(this.value)) {
            return true;
        }
        return ValidationUtils.email(this.value);
    }
    onEnter($event) {
        // Prevent keyup.enter from bubbling if email is invalid.
        if (!this.isValid) {
            $event.stopPropagation();
        }
    }
};
EmailInputComponent.ɵfac = function EmailInputComponent_Factory(t) { return ɵEmailInputComponent_BaseFactory(t || EmailInputComponent); };
EmailInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EmailInputComponent, selectors: [["email-input"]], inputs: { required: "required", disabled: "disabled", invalidFeedback: "invalidFeedback", loading: "loading", placeholder: "placeholder", label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([MakeProvider(EmailInputComponent_1)]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 10, consts: [[1, "searchable", 3, "ngClass"], ["cssClass", "is-email", 3, "placeholder", "label", "ngModel", "isInvalid", "invalidFeedback", "disabled", "ngModelChange", "keyup.enter"], ["class", "searchable-loading", 3, "icon", "spin", 4, "ngIf"], [1, "searchable-loading", 3, "icon", "spin"]], template: function EmailInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "form-input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function EmailInputComponent_Template_form_input_ngModelChange_1_listener($event) { return ctx.value = $event; })("keyup.enter", function EmailInputComponent_Template_form_input_keyup_enter_1_listener($event) { return ctx.onEnter($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, EmailInputComponent_fa_icon_2_Template, 1, 2, "fa-icon", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c0, !!ctx.label));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("label", ctx.label)("ngModel", ctx.value)("isInvalid", !ctx.isValid)("invalidFeedback", ctx.invalidFeedback)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [ɵngcc1.NgClass, FormInputComponent, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc1.NgIf, ɵngcc3.FaIconComponent], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], EmailInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EmailInputComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], EmailInputComponent.prototype, "required", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], EmailInputComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EmailInputComponent.prototype, "invalidFeedback", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], EmailInputComponent.prototype, "loading", void 0);

var SearchInputComponent_1;
let SearchInputComponent = SearchInputComponent_1 = class SearchInputComponent extends AbstractValueAccessor {
};
SearchInputComponent.ɵfac = function SearchInputComponent_Factory(t) { return ɵSearchInputComponent_BaseFactory(t || SearchInputComponent); };
SearchInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchInputComponent, selectors: [["search-input"]], inputs: { placeholder: "placeholder", label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([MakeProvider(SearchInputComponent_1)]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 7, consts: [[1, "clearable", 3, "ngClass"], ["cssClass", "is-search", "type", "text", 3, "placeholder", "label", "ngModel", "ngModelChange"], ["class", "clearable__clear", 3, "click", 4, "ngIf"], [1, "clearable__clear", 3, "click"]], template: function SearchInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "form-input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function SearchInputComponent_Template_form_input_ngModelChange_1_listener($event) { return ctx.value = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, SearchInputComponent_i_2_Template, 2, 0, "i", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, !!ctx.label));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("label", ctx.label)("ngModel", ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.value !== "");
    } }, directives: [ɵngcc1.NgClass, FormInputComponent, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc1.NgIf], styles: [".clearable[_ngcontent-%COMP%]{position:relative;display:inline-block}.clearable[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{padding-right:24px;width:100%;box-sizing:border-box}.clearable__clear[_ngcontent-%COMP%]{display:block;position:absolute;right:1em;top:.4em;padding:0 8px;font-style:normal;font-size:1.6em;color:#9e9e9e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.clearable.has-label[_ngcontent-%COMP%]   .clearable__clear[_ngcontent-%COMP%]{top:41px;right:0}.clearable[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-ms-clear{display:none}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], SearchInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], SearchInputComponent.prototype, "label", void 0);

let NumericInputComponent = class NumericInputComponent {
    constructor() {
        this.readOnly = false;
        this.fieldClass = 'form-control form-input input-with-border';
        this.valueChange = new EventEmitter();
        this.blur = new EventEmitter();
        this.currencyMaskOptions = {
            prefix: '',
            suffix: '',
            thousands: '.',
            decimal: ',',
            align: 'right',
            precision: 0,
            allowNegative: true,
            allowZero: true,
            nullable: true
        };
    }
    set precision(precision) {
        this.currencyMaskOptions = Object.assign(Object.assign({}, this.currencyMaskOptions), { precision });
    }
    set allowNegative(allowNegative) {
        this.currencyMaskOptions = Object.assign(Object.assign({}, this.currencyMaskOptions), { allowNegative });
    }
    set prefix(prefix) {
        this.currencyMaskOptions = Object.assign(Object.assign({}, this.currencyMaskOptions), { prefix });
    }
    set suffix(suffix) {
        this.currencyMaskOptions = Object.assign(Object.assign({}, this.currencyMaskOptions), { suffix });
    }
    ngOnInit() {
        if (!this.id != null && this.name == null) {
            this.name = this.id;
        }
    }
};
NumericInputComponent.ɵfac = function NumericInputComponent_Factory(t) { return new (t || NumericInputComponent)(); };
NumericInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NumericInputComponent, selectors: [["pwc-numeric-input"]], inputs: { readOnly: "readOnly", fieldClass: "fieldClass", precision: "precision", allowNegative: "allowNegative", prefix: "prefix", suffix: "suffix", name: "name", id: "id", value: "value" }, outputs: { valueChange: "valueChange", blur: "blur" }, decls: 1, vars: 6, consts: [["type", "text", "currencyMask", "", 3, "id", "name", "ngClass", "ngModel", "options", "readonly", "ngModelChange", "blur"]], template: function NumericInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function NumericInputComponent_Template_input_ngModelChange_0_listener($event) { return ctx.value = $event; })("ngModelChange", function NumericInputComponent_Template_input_ngModelChange_0_listener($event) { return ctx.valueChange.emit($event); })("blur", function NumericInputComponent_Template_input_blur_0_listener() { return ctx.blur.emit(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", "numeric-input-" + ctx.id)("name", ctx.id)("ngClass", ctx.fieldClass)("ngModel", ctx.value)("options", ctx.currencyMaskOptions)("readonly", ctx.readOnly);
    } }, directives: [ɵngcc2.DefaultValueAccessor, ɵngcc4.CurrencyMaskDirective, ɵngcc1.NgClass, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], NumericInputComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NumericInputComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NumericInputComponent.prototype, "readOnly", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NumericInputComponent.prototype, "fieldClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NumericInputComponent.prototype, "value", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NumericInputComponent.prototype, "valueChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NumericInputComponent.prototype, "blur", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], NumericInputComponent.prototype, "precision", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], NumericInputComponent.prototype, "allowNegative", null);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], NumericInputComponent.prototype, "prefix", null);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], NumericInputComponent.prototype, "suffix", null);

let TimePickerComponent = class TimePickerComponent {
    constructor() {
        this.timeChange = new EventEmitter();
    }
};
TimePickerComponent.ɵfac = function TimePickerComponent_Factory(t) { return new (t || TimePickerComponent)(); };
TimePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimePickerComponent, selectors: [["pwc-time-picker"]], inputs: { time: "time" }, outputs: { timeChange: "timeChange" }, decls: 1, vars: 1, consts: [[3, "ngModel", "ngModelChange"]], template: function TimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function TimePickerComponent_Template_ngb_timepicker_ngModelChange_0_listener($event) { return ctx.timeChange.emit($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.time);
    } }, directives: [ɵngcc5.NgbTimepicker, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], TimePickerComponent.prototype, "time", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], TimePickerComponent.prototype, "timeChange", void 0);

let DateParserFormatterService = class DateParserFormatterService extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = '/';
    }
    parse(value) {
        if (value) {
            let date = value.split(this.DELIMITER);
            let day = parseInt(date[0], 10);
            let month = parseInt(date[1], 10);
            let year = parseInt(date[2], 10);
            if (day <= 0) {
                day = 1;
            }
            else if (day > 31) {
                day = 31;
            }
            if (month <= 0) {
                month = 1;
            }
            else if (month > 12) {
                month = 1;
            }
            return {
                day,
                month,
                year
            };
        }
        return null;
    }
    format(date) {
        return DateUtils.formatLocalDate(date, DateUtils.HUMAN_FORMAT);
    }
};
DateParserFormatterService.ɵfac = function DateParserFormatterService_Factory(t) { return ɵDateParserFormatterService_BaseFactory(t || DateParserFormatterService); };
DateParserFormatterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DateParserFormatterService, factory: DateParserFormatterService.ɵfac });

let DateInputComponent = class DateInputComponent {
    constructor(iconsLibrary) {
        this.iconsLibrary = iconsLibrary;
        this.id = '';
        this.readOnly = false;
        this.dateChange = new EventEmitter();
        this.blur = new EventEmitter();
        this.iconsLibrary.registerIcons([
            piCalendarSmall
        ]);
    }
    toggleDatePicker() {
        if (this.readOnly) {
            return;
        }
        this.datePicker.toggle();
    }
    onDateChange($event) {
        this.dateChange.emit($event);
    }
};
DateInputComponent.ɵfac = function DateInputComponent_Factory(t) { return new (t || DateInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.PwcIconsLibrary)); };
DateInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateInputComponent, selectors: [["pwc-date-input"]], viewQuery: function DateInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c1, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePicker = _t.first);
    } }, inputs: { id: "id", readOnly: "readOnly", date: "date" }, outputs: { dateChange: "dateChange", blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NgbDateParserFormatter, useClass: DateParserFormatterService }
        ])], decls: 4, vars: 4, consts: [["type", "text", "placeholder", "DD/MM/YYYY", "container", "body", "ngbDatepicker", "", "rInputMask", "99/99/9999", 1, "form-control", "form-input", "input-with-border", 3, "id", "name", "ngModel", "readOnly", "ngModelChange", "blur", "dateSelect"], ["datePicker", "ngbDatepicker"], [1, "form-input-icon", "append", "pointer", 2, "right", "25px", 3, "click"], ["name", "calendar_small"]], template: function DateInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DateInputComponent_Template_input_ngModelChange_0_listener($event) { return ctx.date = $event; })("ngModelChange", function DateInputComponent_Template_input_ngModelChange_0_listener($event) { return ctx.onDateChange($event); })("blur", function DateInputComponent_Template_input_blur_0_listener() { return ctx.blur.emit(ctx.date); })("dateSelect", function DateInputComponent_Template_input_dateSelect_0_listener() { return ctx.blur.emit(ctx.date); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function DateInputComponent_Template_div_click_2_listener() { return ctx.toggleDatePicker(); });
        ɵngcc0.ɵɵelement(3, "pwc-icon", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("name", ctx.id)("ngModel", ctx.date)("readOnly", ctx.readOnly);
    } }, directives: [ɵngcc5.NgbInputDatepicker, ɵngcc2.DefaultValueAccessor, ɵngcc7.InputMaskDirective, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc6.PwcIconComponent], styles: [""] });
DateInputComponent.ctorParameters = () => [
    { type: PwcIconsLibrary }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], DateInputComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], DateInputComponent.prototype, "date", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], DateInputComponent.prototype, "readOnly", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DateInputComponent.prototype, "dateChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DateInputComponent.prototype, "blur", void 0);
__decorate([
    ViewChild('datePicker', { static: true }),
    __metadata("design:type", NgbInputDatepicker)
], DateInputComponent.prototype, "datePicker", void 0);
DateInputComponent = __decorate([ __metadata("design:paramtypes", [PwcIconsLibrary])
], DateInputComponent);

let FormsModule = class FormsModule {
};
FormsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FormsModule });
FormsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FormsModule_Factory(t) { return new (t || FormsModule)(); }, imports: [[
            CommonModule,
            FormsModule$1,
            ReactiveFormsModule,
            UIModule,
            I18nModule,
            TranslateModule.forChild(),
            PwcIconsModule,
            NgbTimepickerModule,
            NgxCurrencyModule,
            InputMaskModule
        ],
        FormsModule$1,
        ReactiveFormsModule] });

function isElement(node) {
    return !!(node && (node.nodeName || node.prop && node.attr && node.find));
}
class FileLikeObject {
    constructor(fileOrInput) {
        this.rawFile = fileOrInput;
        let isInput = isElement(fileOrInput);
        let fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
        let postfix = typeof fakePathOrObject === 'string' ? 'FakePath' : 'Object';
        let method = '_createFrom' + postfix;
        this[method](fakePathOrObject);
    }
    _createFromFakePath(path) {
        this.lastModifiedDate = void 0;
        this.size = void 0;
        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
    }
    _createFromObject(object) {
        this.size = object.size;
        this.type = object.type;
        this.name = object.name;
    }
}

class FileItem {
    constructor(uploader, some, options) {
        this.url = '/';
        this.headers = [];
        this.withCredentials = true;
        this.formData = [];
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.uploader = uploader;
        this.some = some;
        this.options = options;
        this.file = new FileLikeObject(some);
        this._file = some;
        if (uploader.options) {
            this.method = uploader.options.method || 'POST';
            this.alias = uploader.options.itemAlias || 'file';
        }
        this.url = uploader.options.url;
    }
    upload() {
        try {
            this.uploader.uploadItem(this);
        }
        catch (e) {
            this.uploader._onCompleteItem(this, '', 0, {});
            this.uploader._onErrorItem(this, '', 0, {});
        }
    }
    cancel() {
        this.uploader.cancelItem(this);
    }
    remove() {
        this.uploader.removeFromQueue(this);
    }
    onBeforeUpload() {
        return void 0;
    }
    onBuildForm(form) {
        return { form };
    }
    onProgress(progress) {
        return { progress };
    }
    onSuccess(response, status, headers) {
        return { response, status, headers };
    }
    onError(response, status, headers) {
        return { response, status, headers };
    }
    onCancel(response, status, headers) {
        return { response, status, headers };
    }
    onComplete(response, status, headers) {
        return { response, status, headers };
    }
    _onBeforeUpload() {
        this.isReady = true;
        this.isUploading = true;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.onBeforeUpload();
    }
    _onBuildForm(form) {
        this.onBuildForm(form);
    }
    _onProgress(progress) {
        this.progress = progress;
        this.onProgress(progress);
    }
    _onSuccess(response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = true;
        this.isCancel = false;
        this.isError = false;
        this.progress = 100;
        this.index = void 0;
        this.onSuccess(response, status, headers);
    }
    _onError(response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = true;
        this.progress = 0;
        this.index = void 0;
        this.onError(response, status, headers);
    }
    _onCancel(response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = true;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.onCancel(response, status, headers);
    }
    _onComplete(response, status, headers) {
        this.onComplete(response, status, headers);
        if (this.uploader.options.removeAfterUpload) {
            this.remove();
        }
    }
    _prepareToUploading() {
        this.index = this.index || ++this.uploader._nextIndex;
        this.isReady = true;
    }
}

class FileType {
    static getMimeClass(file) {
        let mimeClass = 'application';
        if (this.mime_psd.indexOf(file.type) !== -1) {
            mimeClass = 'image';
        }
        else if (file.type.match('image.*')) {
            mimeClass = 'image';
        }
        else if (file.type.match('video.*')) {
            mimeClass = 'video';
        }
        else if (file.type.match('audio.*')) {
            mimeClass = 'audio';
        }
        else if (file.type === 'application/pdf') {
            mimeClass = 'pdf';
        }
        else if (this.mime_compress.indexOf(file.type) !== -1) {
            mimeClass = 'compress';
        }
        else if (this.mime_doc.indexOf(file.type) !== -1) {
            mimeClass = 'doc';
        }
        else if (this.mime_xsl.indexOf(file.type) !== -1) {
            mimeClass = 'xls';
        }
        else if (this.mime_ppt.indexOf(file.type) !== -1) {
            mimeClass = 'ppt';
        }
        if (mimeClass === 'application') {
            mimeClass = this.fileTypeDetection(file.name);
        }
        return mimeClass;
    }
    static fileTypeDetection(inputFilename) {
        let types = {
            'jpg': 'image',
            'jpeg': 'image',
            'tif': 'image',
            'psd': 'image',
            'bmp': 'image',
            'png': 'image',
            'nef': 'image',
            'tiff': 'image',
            'cr2': 'image',
            'dwg': 'image',
            'cdr': 'image',
            'ai': 'image',
            'indd': 'image',
            'pin': 'image',
            'cdp': 'image',
            'skp': 'image',
            'stp': 'image',
            '3dm': 'image',
            'mp3': 'audio',
            'wav': 'audio',
            'wma': 'audio',
            'mod': 'audio',
            'm4a': 'audio',
            'compress': 'compress',
            'zip': 'compress',
            'rar': 'compress',
            '7z': 'compress',
            'lz': 'compress',
            'z01': 'compress',
            'bz2': 'compress',
            'gz': 'compress',
            'pdf': 'pdf',
            'xls': 'xls',
            'xlsx': 'xls',
            'ods': 'xls',
            'mp4': 'video',
            'avi': 'video',
            'wmv': 'video',
            'mpg': 'video',
            'mts': 'video',
            'flv': 'video',
            '3gp': 'video',
            'vob': 'video',
            'm4v': 'video',
            'mpeg': 'video',
            'm2ts': 'video',
            'mov': 'video',
            'doc': 'doc',
            'docx': 'doc',
            'eps': 'doc',
            'txt': 'doc',
            'odt': 'doc',
            'rtf': 'doc',
            'ppt': 'ppt',
            'pptx': 'ppt',
            'pps': 'ppt',
            'ppsx': 'ppt',
            'odp': 'ppt'
        };
        let chunks = inputFilename.split('.');
        if (chunks.length < 2) {
            return 'application';
        }
        let extension = chunks[chunks.length - 1].toLowerCase();
        if (types[extension] === undefined) {
            return 'application';
        }
        else {
            return types[extension];
        }
    }
}
/*  MS office  */
FileType.mime_doc = [
    'application/msword',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.ms-word.template.macroEnabled.12'
];
FileType.mime_xsl = [
    'application/vnd.ms-excel',
    'application/vnd.ms-excel',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
];
FileType.mime_ppt = [
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];
/* PSD */
FileType.mime_psd = [
    'image/photoshop',
    'image/x-photoshop',
    'image/psd',
    'application/photoshop',
    'application/psd',
    'zz-application/zz-winassoc-psd'
];
/* Compressed files */
FileType.mime_compress = [
    'application/x-gtar',
    'application/x-gcompress',
    'application/compress',
    'application/x-tar',
    'application/x-rar-compressed',
    'application/octet-stream',
    'application/x-zip-compressed',
    'application/zip-compressed',
    'application/x-7z-compressed',
    'application/gzip',
    'application/x-bzip2'
];

function isFile(value) {
    return (File && value instanceof File);
}
class FileUploader {
    constructor(options) {
        this.isUploading = false;
        this.queue = [];
        this.progress = 0;
        this._nextIndex = 0;
        this.options = {
            autoUpload: false,
            isHTML5: true,
            filters: [],
            removeAfterUpload: false,
            disableMultipart: false,
            formatDataFunction: (item) => item._file,
            formatDataFunctionIsAsync: false
        };
        this.setOptions(options);
        this.response = new EventEmitter();
    }
    setOptions(options) {
        this.options = Object.assign(this.options, options);
        this.authToken = this.options.authToken;
        this.authTokenHeader = this.options.authTokenHeader || 'Authorization';
        this.autoUpload = this.options.autoUpload;
        this.options.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
        if (this.options.maxFileSize) {
            this.options.filters.unshift({ name: 'fileSize', fn: this._fileSizeFilter });
        }
        if (this.options.allowedFileType) {
            this.options.filters.unshift({ name: 'fileType', fn: this._fileTypeFilter });
        }
        if (this.options.allowedMimeType) {
            this.options.filters.unshift({ name: 'mimeType', fn: this._mimeTypeFilter });
        }
        for (let i = 0; i < this.queue.length; i++) {
            this.queue[i].url = this.options.url;
        }
    }
    addToQueue(files, options, filters) {
        let list = [];
        for (let file of files) {
            list.push(file);
        }
        let arrayOfFilters = this._getFilters(filters);
        let count = this.queue.length;
        let addedFileItems = [];
        list.map((some) => {
            if (!options) {
                options = this.options;
            }
            let temp = new FileLikeObject(some);
            if (this._isValidFile(temp, arrayOfFilters, options)) {
                let fileItem = new FileItem(this, some, options);
                addedFileItems.push(fileItem);
                this.queue.push(fileItem);
                this._onAfterAddingFile(fileItem);
            }
            else {
                let filter = arrayOfFilters[this._failFilterIndex];
                this._onWhenAddingFileFailed(temp, filter, options);
            }
        });
        if (this.queue.length !== count) {
            this._onAfterAddingAll(addedFileItems);
            this.progress = this._getTotalProgress();
        }
        this._render();
        if (this.options.autoUpload) {
            this.uploadAll();
        }
    }
    removeFromQueue(value) {
        let index = this.getIndexOfItem(value);
        let item = this.queue[index];
        if (item.isUploading) {
            item.cancel();
        }
        this.queue.splice(index, 1);
        this.progress = this._getTotalProgress();
    }
    clearQueue() {
        while (this.queue.length) {
            this.queue[0].remove();
        }
        this.progress = 0;
    }
    uploadItem(value) {
        let index = this.getIndexOfItem(value);
        let item = this.queue[index];
        let transport = this.options.isHTML5 ? '_xhrTransport' : '_iframeTransport';
        item._prepareToUploading();
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        this[transport](item);
    }
    cancelItem(value) {
        let index = this.getIndexOfItem(value);
        let item = this.queue[index];
        let prop = this.options.isHTML5 ? item._xhr : item._form;
        if (item && item.isUploading) {
            prop.abort();
        }
    }
    uploadAll() {
        let items = this.getNotUploadedItems().filter((item) => !item.isUploading);
        if (!items.length) {
            return;
        }
        items.map((item) => item._prepareToUploading());
        items[0].upload();
    }
    cancelAll() {
        let items = this.getNotUploadedItems();
        items.map((item) => item.cancel());
    }
    isFile(value) {
        return isFile(value);
    }
    isFileLikeObject(value) {
        return value instanceof FileLikeObject;
    }
    getIndexOfItem(value) {
        return typeof value === 'number' ? value : this.queue.indexOf(value);
    }
    getNotUploadedItems() {
        return this.queue.filter((item) => !item.isUploaded);
    }
    getReadyItems() {
        return this.queue
            .filter((item) => (item.isReady && !item.isUploading))
            .sort((item1, item2) => item1.index - item2.index);
    }
    destroy() {
        return void 0;
    }
    onAfterAddingAll(fileItems) {
        return { fileItems };
    }
    onBuildItemForm(fileItem, form) {
        return { fileItem, form };
    }
    onAfterAddingFile(fileItem) {
        return { fileItem };
    }
    onWhenAddingFileFailed(item, filter, options) {
        return { item, filter, options };
    }
    onBeforeUploadItem(fileItem) {
        return { fileItem };
    }
    onProgressItem(fileItem, progress) {
        return { fileItem, progress };
    }
    onProgressAll(progress) {
        return { progress };
    }
    onSuccessItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onErrorItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onCancelItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onCompleteItem(item, response, status, headers) {
        return { item, response, status, headers };
    }
    onCompleteAll() {
        return void 0;
    }
    _mimeTypeFilter(item) {
        return !(this.options.allowedMimeType && this.options.allowedMimeType.indexOf(item.type) === -1);
    }
    _fileSizeFilter(item) {
        return !(this.options.maxFileSize && item.size > this.options.maxFileSize);
    }
    _fileTypeFilter(item) {
        return !(this.options.allowedFileType &&
            this.options.allowedFileType.indexOf(FileType.getMimeClass(item)) === -1);
    }
    _onErrorItem(item, response, status, headers) {
        item._onError(response, status, headers);
        this.onErrorItem(item, response, status, headers);
    }
    _onCompleteItem(item, response, status, headers) {
        item._onComplete(response, status, headers);
        this.onCompleteItem(item, response, status, headers);
        let nextItem = this.getReadyItems()[0];
        this.isUploading = false;
        if (nextItem) {
            nextItem.upload();
            return;
        }
        this.onCompleteAll();
        this.progress = this._getTotalProgress();
        this._render();
    }
    _headersGetter(parsedHeaders) {
        return (name) => {
            if (name) {
                return parsedHeaders[name.toLowerCase()] || void 0;
            }
            return parsedHeaders;
        };
    }
    _xhrTransport(item) {
        let that = this;
        let xhr = item._xhr = new XMLHttpRequest();
        let sendable;
        this._onBeforeUploadItem(item);
        if (typeof item._file.size !== 'number') {
            throw new TypeError('The file specified is no longer valid');
        }
        if (!this.options.disableMultipart) {
            sendable = new FormData();
            this._onBuildItemForm(item, sendable);
            const appendFile = () => sendable.append(item.alias, item._file, item.file.name);
            if (!this.options.parametersBeforeFiles) {
                appendFile();
            }
            // For AWS, Additional Parameters must come BEFORE Files
            let additionalParameters = this.options.additionalParameter || {};
            if (typeof item.options.additionalParameter !== 'undefined') {
                additionalParameters = Object.assign(Object.assign({}, additionalParameters), item.options.additionalParameter);
            }
            Object.keys(additionalParameters).forEach((key) => {
                let paramVal = additionalParameters[key];
                // Allow an additional parameter to include the filename
                if (typeof paramVal === 'string' && paramVal.indexOf('{{file_name}}') >= 0) {
                    paramVal = paramVal.replace('{{file_name}}', item.file.name);
                }
                sendable.append(key, paramVal);
            });
            if (this.options.parametersBeforeFiles) {
                appendFile();
            }
        }
        else {
            sendable = this.options.formatDataFunction(item);
        }
        xhr.upload.onprogress = (event) => {
            let progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
            this._onProgressItem(item, progress);
        };
        xhr.onload = () => {
            let headers = this._parseHeaders(xhr.getAllResponseHeaders());
            let response = this._transformResponse(xhr.response, headers);
            let gist = this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
            let method = '_on' + gist + 'Item';
            this[method](item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.onerror = () => {
            let headers = this._parseHeaders(xhr.getAllResponseHeaders());
            let response = this._transformResponse(xhr.response, headers);
            this._onErrorItem(item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.onabort = () => {
            let headers = this._parseHeaders(xhr.getAllResponseHeaders());
            let response = this._transformResponse(xhr.response, headers);
            this._onCancelItem(item, response, xhr.status, headers);
            this._onCompleteItem(item, response, xhr.status, headers);
        };
        xhr.open(item.method, item.url, true);
        xhr.withCredentials = item.withCredentials;
        if (this.options.headers) {
            for (let header of this.options.headers) {
                xhr.setRequestHeader(header.name, header.value);
            }
        }
        if (item.headers.length) {
            for (let header of item.headers) {
                xhr.setRequestHeader(header.name, header.value);
            }
        }
        if (this.authToken) {
            xhr.setRequestHeader(this.authTokenHeader, this.authToken);
        }
        xhr.onreadystatechange = function () {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                that.response.emit(xhr.responseText);
            }
        };
        if (this.options.formatDataFunctionIsAsync) {
            sendable.then((result) => xhr.send(JSON.stringify(result)));
        }
        else {
            xhr.send(sendable);
        }
        this._render();
    }
    _getTotalProgress(value = 0) {
        if (this.options.removeAfterUpload) {
            return value;
        }
        let notUploaded = this.getNotUploadedItems().length;
        let uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
        let ratio = 100 / this.queue.length;
        let current = value * ratio / 100;
        return Math.round(uploaded * ratio + current);
    }
    _getFilters(filters) {
        if (!filters) {
            return this.options.filters;
        }
        if (Array.isArray(filters)) {
            return filters;
        }
        if (typeof filters === 'string') {
            let names = filters.match(/[^\s,]+/g);
            return this.options.filters
                .filter((filter) => names.indexOf(filter.name) !== -1);
        }
        return this.options.filters;
    }
    _render() {
        return void 0;
    }
    _queueLimitFilter() {
        return this.options.queueLimit === undefined || this.queue.length < this.options.queueLimit;
    }
    _isValidFile(file, filters, options) {
        this._failFilterIndex = -1;
        return !filters.length ? true : filters.every((filter) => {
            this._failFilterIndex++;
            return filter.fn.call(this, file, options);
        });
    }
    _isSuccessCode(status) {
        return (status >= 200 && status < 300) || status === 304;
    }
    _transformResponse(response, headers) {
        return response;
    }
    _parseHeaders(headers) {
        let parsed = {};
        let key;
        let val;
        let i;
        if (!headers) {
            return parsed;
        }
        headers.split('\n').map((line) => {
            i = line.indexOf(':');
            key = line.slice(0, i).trim().toLowerCase();
            val = line.slice(i + 1).trim();
            if (key) {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
        });
        return parsed;
    }
    _onWhenAddingFileFailed(item, filter, options) {
        this.onWhenAddingFileFailed(item, filter, options);
    }
    _onAfterAddingFile(item) {
        this.onAfterAddingFile(item);
    }
    _onAfterAddingAll(items) {
        this.onAfterAddingAll(items);
    }
    _onBeforeUploadItem(item) {
        item._onBeforeUpload();
        this.onBeforeUploadItem(item);
    }
    _onBuildItemForm(item, form) {
        item._onBuildForm(form);
        this.onBuildItemForm(item, form);
    }
    _onProgressItem(item, progress) {
        let total = this._getTotalProgress(progress);
        this.progress = total;
        item._onProgress(progress);
        this.onProgressItem(item, progress);
        this.onProgressAll(total);
        this._render();
    }
    _onSuccessItem(item, response, status, headers) {
        item._onSuccess(response, status, headers);
        this.onSuccessItem(item, response, status, headers);
    }
    _onCancelItem(item, response, status, headers) {
        item._onCancel(response, status, headers);
        this.onCancelItem(item, response, status, headers);
    }
}

let FileDropDirective = class FileDropDirective {
    constructor(element) {
        this.fileOver = new EventEmitter();
        this.onFileDrop = new EventEmitter();
        this.element = element;
    }
    getOptions() {
        return this.uploader.options;
    }
    getFilters() {
        return {};
    }
    onDrop(event) {
        let transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        let options = this.getOptions();
        let filters = this.getFilters();
        this._preventAndStop(event);
        this.uploader.addToQueue(transfer.files, options, filters);
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    }
    onDragOver(event) {
        let transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.fileOver.emit(true);
    }
    onDragLeave(event) {
        if (this.element) {
            if (event.currentTarget === this.element[0]) {
                return;
            }
        }
        this._preventAndStop(event);
        this.fileOver.emit(false);
    }
    _getTransfer(event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }
    _preventAndStop(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    _haveFiles(types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        else if (types.contains) {
            return types.contains('Files');
        }
        else {
            return false;
        }
    }
};
FileDropDirective.ɵfac = function FileDropDirective_Factory(t) { return new (t || FileDropDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FileDropDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FileDropDirective, selectors: [["", "ng2FileDrop", ""]], hostBindings: function FileDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("drop", function FileDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("dragover", function FileDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function FileDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); });
    } }, inputs: { uploader: "uploader" }, outputs: { fileOver: "fileOver", onFileDrop: "onFileDrop" } });
FileDropDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", FileUploader)
], FileDropDirective.prototype, "uploader", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FileDropDirective.prototype, "fileOver", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FileDropDirective.prototype, "onFileDrop", void 0);
__decorate([
    HostListener('drop', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDropDirective.prototype, "onDrop", null);
__decorate([
    HostListener('dragover', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FileDropDirective.prototype, "onDragOver", null);
__decorate([
    HostListener('dragleave', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], FileDropDirective.prototype, "onDragLeave", null);
FileDropDirective = __decorate([ __metadata("design:paramtypes", [ElementRef])
], FileDropDirective);

let FileSelectDirective = class FileSelectDirective {
    constructor(element) {
        this.onFileSelected = new EventEmitter();
        this.element = element;
    }
    getOptions() {
        return this.uploader.options;
    }
    getFilters() {
        return {};
    }
    isEmptyAfterSelection() {
        return !!this.element.nativeElement.attributes.multiple;
    }
    onChange() {
        let files = this.element.nativeElement.files;
        let options = this.getOptions();
        let filters = this.getFilters();
        this.uploader.addToQueue(files, options, filters);
        this.onFileSelected.emit(files);
        if (this.isEmptyAfterSelection()) {
            this.element.nativeElement.value = '';
        }
    }
};
FileSelectDirective.ɵfac = function FileSelectDirective_Factory(t) { return new (t || FileSelectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FileSelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: FileSelectDirective, selectors: [["", "ng2FileSelect", ""]], hostBindings: function FileSelectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function FileSelectDirective_change_HostBindingHandler() { return ctx.onChange(); });
    } }, inputs: { uploader: "uploader" }, outputs: { onFileSelected: "onFileSelected" } });
FileSelectDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", FileUploader)
], FileSelectDirective.prototype, "uploader", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FileSelectDirective.prototype, "onFileSelected", void 0);
__decorate([
    HostListener('change'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], FileSelectDirective.prototype, "onChange", null);
FileSelectDirective = __decorate([ __metadata("design:paramtypes", [ElementRef])
], FileSelectDirective);

let DirectoryDropDirective = class DirectoryDropDirective extends FileDropDirective {
    constructor(element, changeDetector) {
        super(element);
        this.changeDetector = changeDetector;
    }
    onDrop(event) {
        const transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        const options = this.getOptions();
        const filters = this.getFilters();
        this._preventAndStop(event);
        this.manageDropEvent(transfer, options, filters);
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    }
    manageDropEvent(transfer, options, filters) {
        for (const item of transfer.items) {
            if (typeof item.webkitGetAsEntry !== 'function') {
                console.warn('webkitGetAsEntry feature not supported, cannot handle upload of directory.');
                this.uploader.addToQueue(transfer.files, options, filters);
                return;
            }
            const entry = item.webkitGetAsEntry();
            if (entry) {
                this.traverseFileTree(entry, options, filters);
            }
        }
    }
    traverseFileTree(item, options, filters) {
        if (item.isFile) {
            const fullPath = item.fullPath;
            const isDirUpload = true;
            item.file((file) => {
                const opts = Object.assign(Object.assign({}, options), { additionalParameter: {
                        fullPath,
                        isDirUpload
                    } });
                console.debug('options', opts);
                this.uploader.addToQueue([file], opts, filters);
                this.changeDetector.detectChanges();
            });
        }
        else if (item.isDirectory) {
            const dirReader = item.createReader();
            dirReader.readEntries((entries) => {
                for (const entry of entries) {
                    this.traverseFileTree(entry, options, filters);
                }
            });
        }
    }
};
DirectoryDropDirective.ɵfac = function DirectoryDropDirective_Factory(t) { return new (t || DirectoryDropDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DirectoryDropDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DirectoryDropDirective, selectors: [["", "directoryDrop", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
DirectoryDropDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
DirectoryDropDirective = __decorate([ __metadata("design:paramtypes", [ElementRef,
        ChangeDetectorRef])
], DirectoryDropDirective);

let DirectorySelectDirective = class DirectorySelectDirective extends FileSelectDirective {
    onChange() {
        const files = this.element.nativeElement.files;
        const options = this.getOptions();
        const filters = this.getFilters();
        this.manageSelectEvent(files, options, filters);
        this.onFileSelected.emit(files);
        if (this.isEmptyAfterSelection()) {
            this.element.nativeElement.value = '';
        }
    }
    manageSelectEvent(files, options, filters) {
        for (const file of files) {
            const fullPath = file.webkitRelativePath;
            const isDirUpload = true;
            this.uploader.addToQueue([file], Object.assign(Object.assign({}, options), { additionalParameter: {
                    fullPath,
                    isDirUpload
                } }), filters);
        }
    }
};
DirectorySelectDirective.ɵfac = function DirectorySelectDirective_Factory(t) { return ɵDirectorySelectDirective_BaseFactory(t || DirectorySelectDirective); };
DirectorySelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DirectorySelectDirective, selectors: [["", "directorySelect", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });

let FileUploadModule = class FileUploadModule {
};
FileUploadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FileUploadModule });
FileUploadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FileUploadModule_Factory(t) { return new (t || FileUploadModule)(); }, imports: [[CommonModule]] });

var FilterType;
(function (FilterType) {
    FilterType["TEXT"] = "TEXT";
    FilterType["NUMBER"] = "NUMBER";
    FilterType["DATE"] = "DATE";
    FilterType["SELECT"] = "SELECT";
    FilterType["MULTISELECT"] = "MULTISELECT";
})(FilterType || (FilterType = {}));

let FiltersComponent = class FiltersComponent {
    constructor(pwcIconsLibrary) {
        this.pwcIconsLibrary = pwcIconsLibrary;
        this.valuesChange = new EventEmitter();
        this.clear = new EventEmitter();
        this.FilterType = FilterType;
        this.pwcIconsLibrary.registerIcons([
            piClear
        ]);
    }
    onChange() {
        this.valuesChange.emit(this.values);
    }
    isSelect(type) {
        return type === FilterType.SELECT || type === FilterType.MULTISELECT;
    }
    onOptionChange(config) {
        if (config.onChangeFn != null)
            config.onChangeFn();
        this.valuesChange.emit(this.values);
    }
    isVisible(field) {
        return typeof (field.visible) == "undefined" || field.visible;
    }
};
FiltersComponent.ɵfac = function FiltersComponent_Factory(t) { return new (t || FiltersComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.PwcIconsLibrary)); };
FiltersComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FiltersComponent, selectors: [["pwc-filters"]], inputs: { config: "config", values: "values" }, outputs: { valuesChange: "valuesChange", clear: "clear" }, ngContentSelectors: _c2, decls: 1, vars: 1, consts: [["class", "card my-4", 4, "ngIf"], [1, "card", "my-4"], [1, "card-body"], [1, "card-title"], ["translate", ""], ["onmousedown", "event.preventDefault();", "type", "button", 1, "btn", "btn-primary", "btn-sm", "btn-action-icon", "ml-0", "btn-clear-filter", 3, "ngbTooltip", "click"], ["name", "clear"], [1, "d-flex", "flex-row", "justify-content-between", "align-items-end"], [1, "d-flex", "flex-row", "flex-wrap"], [4, "ngFor", "ngForOf"], ["class", "form-group filter-item mr-4", 4, "ngIf"], [1, "form-group", "filter-item", "mr-4"], [1, "form-input-label", "no-wrap-label", 3, "for"], ["class", "form-group form-input-group", 4, "ngIf"], ["class", "no-shadow", "style", "padding:0", 3, "id", "name", "placeholder", "ngModel", "searchable", "clearable", "multiple", "ngModelChange", "change", "remove", "clear", 4, "ngIf"], [1, "form-group", "form-input-group"], ["type", "text", "class", "form-control form-input no-shadow input-with-border", 3, "id", "name", "ngModel", "ngModelChange", 4, "ngIf"], [3, "id", "date", "dateChange", 4, "ngIf"], ["type", "text", 1, "form-control", "form-input", "no-shadow", "input-with-border", 3, "id", "name", "ngModel", "ngModelChange"], [3, "id", "date", "dateChange"], [1, "no-shadow", 2, "padding", "0", 3, "id", "name", "placeholder", "ngModel", "searchable", "clearable", "multiple", "ngModelChange", "change", "remove", "clear"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function FiltersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, FiltersComponent_div_0_Template, 12, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config && ctx.values);
    } }, directives: [ɵngcc1.NgIf, ɵngcc8.TranslateDirective, ɵngcc5.NgbTooltip, ɵngcc6.PwcIconComponent, ɵngcc1.NgForOf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, DateInputComponent, ɵngcc9.NgSelectComponent, ɵngcc9.ɵr], pipes: [ɵngcc8.TranslatePipe], styles: [""] });
FiltersComponent.ctorParameters = () => [
    { type: PwcIconsLibrary }
];
__decorate([
    Input(),
    __metadata("design:type", Array)
], FiltersComponent.prototype, "config", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], FiltersComponent.prototype, "values", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FiltersComponent.prototype, "valuesChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FiltersComponent.prototype, "clear", void 0);
FiltersComponent = __decorate([ __metadata("design:paramtypes", [PwcIconsLibrary])
], FiltersComponent);

let FiltersModule = class FiltersModule {
};
FiltersModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FiltersModule });
FiltersModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FiltersModule_Factory(t) { return new (t || FiltersModule)(); }, imports: [[
            CommonModule$1,
            FormsModule,
            UIModule,
            I18nModule,
            TranslateModule.forChild(),
            PwcIconsModule,
            NgSelectModule
        ]] });
const ɵFormInputComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FormInputComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormInputComponent, [{
        type: Component,
        args: [{
                selector: 'form-input',
                template: "<div class=\"form-group form-input-group\">\n  <label class=\"form-input-label\" *ngIf=\"label\">{{label}}</label>\n  <input [type]=\"type\" [(ngModel)]=\"value\" class=\"form-control form-input\" [ngClass]=\"classes\"\n         [placeholder]=\"placeholder\" [disabled]=\"disabled\" [id]=\"id\" [name]=\"name\">\n  <div class=\"invalid-feedback\" *ngIf=\"invalidFeedback && isInvalid\">{{invalidFeedback}}</div>\n</div>\n",
                providers: [MakeProvider(FormInputComponent_1)],
                styles: [""]
            }]
    }], null, { type: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isInvalid: [{
            type: Input
        }], name: [{
            type: Input
        }], id: [{
            type: Input
        }], cssClass: [{
            type: Input
        }], label: [{
            type: Input
        }], invalidFeedback: [{
            type: Input
        }] }); })();
const ɵEmailInputComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(EmailInputComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmailInputComponent, [{
        type: Component,
        args: [{
                selector: 'email-input',
                template: "<div class=\"searchable\" [ngClass]=\"{'has-label': !!label}\">\n  <form-input [placeholder]=\"placeholder\" [label]=\"label\" cssClass=\"is-email\" [(ngModel)]=\"value\" (keyup.enter)=\"onEnter($event)\"\n              [isInvalid]=\"!this.isValid\" [invalidFeedback]=\"invalidFeedback\" [disabled]=\"disabled\"></form-input>\n  <fa-icon [icon]=\"faCircleNotch\" [spin]=\"true\" class=\"searchable-loading\" *ngIf=\"loading\"></fa-icon>\n</div>\n",
                providers: [MakeProvider(EmailInputComponent_1)],
                styles: [""]
            }]
    }], null, { required: [{
            type: Input
        }], disabled: [{
            type: Input
        }], invalidFeedback: [{
            type: Input
        }], loading: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
const ɵSearchInputComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SearchInputComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchInputComponent, [{
        type: Component,
        args: [{
                selector: 'search-input',
                template: "<div class=\"clearable\" [ngClass]=\"{'has-label': !!label}\">\n  <form-input [placeholder]=\"placeholder\" [label]=\"label\" cssClass=\"is-search\" [(ngModel)]=\"value\"\n              type=\"text\"></form-input>\n  <i class=\"clearable__clear\" (click)=\"value = ''\" *ngIf=\"value !== ''\">&times;</i>\n</div>\n",
                providers: [MakeProvider(SearchInputComponent_1)],
                styles: [".clearable{position:relative;display:inline-block}.clearable input[type=text]{padding-right:24px;width:100%;box-sizing:border-box}.clearable__clear{display:block;position:absolute;right:1em;top:.4em;padding:0 8px;font-style:normal;font-size:1.6em;color:#9e9e9e;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}.clearable.has-label .clearable__clear{top:41px;right:0}.clearable input::-ms-clear{display:none}"]
            }]
    }], null, { placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NumericInputComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-numeric-input',
                template: "<input type=\"text\"\n       [id]=\"'numeric-input-' + id\"\n       [name]=\"id\"\n       [ngClass]=\"fieldClass\"\n       [(ngModel)]=\"value\"\n       (ngModelChange)=\"valueChange.emit($event)\"\n       (blur)=\"blur.emit()\"\n       currencyMask\n       [options]=\"currencyMaskOptions\"\n       [readonly]=\"readOnly\">\n",
                styles: [""]
            }]
    }], function () { return []; }, { readOnly: [{
            type: Input
        }], fieldClass: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], blur: [{
            type: Output
        }], precision: [{
            type: Input
        }], allowNegative: [{
            type: Input
        }], prefix: [{
            type: Input
        }], suffix: [{
            type: Input
        }], name: [{
            type: Input
        }], id: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-time-picker',
                template: "<ngb-timepicker [ngModel]=\"time\"\n                (ngModelChange)=\"timeChange.emit($event)\">\n</ngb-timepicker>\n",
                styles: [""]
            }]
    }], function () { return []; }, { timeChange: [{
            type: Output
        }], time: [{
            type: Input
        }] }); })();
const ɵDateParserFormatterService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DateParserFormatterService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateParserFormatterService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateInputComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-date-input',
                template: "<input type=\"text\" [id]=\"id\" [name]=\"id\"\n       class=\"form-control form-input input-with-border\"\n       placeholder=\"DD/MM/YYYY\"\n       container=\"body\"\n       ngbDatepicker #datePicker=\"ngbDatepicker\"\n       rInputMask=\"99/99/9999\"\n       [(ngModel)]=\"date\"\n       (ngModelChange)=\"onDateChange($event)\"\n       (blur)=\"blur.emit(date)\"\n       (dateSelect)=\"blur.emit(date)\"\n       [readOnly]=\"readOnly\"\n>\n<div (click)=\"toggleDatePicker()\" class=\"form-input-icon append pointer\" style=\"right: 25px;\">\n  <pwc-icon name=\"calendar_small\"></pwc-icon>\n</div>\n",
                providers: [
                    { provide: NgbDateParserFormatter, useClass: DateParserFormatterService }
                ],
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc6.PwcIconsLibrary }]; }, { id: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], blur: [{
            type: Output
        }], date: [{
            type: Input
        }], datePicker: [{
            type: ViewChild,
            args: ['datePicker', { static: true }]
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FormsModule, { declarations: function () { return [FormInputComponent,
        EmailInputComponent,
        SearchInputComponent,
        NumericInputComponent,
        TimePickerComponent,
        DateInputComponent]; }, imports: function () { return [CommonModule,
        FormsModule$1,
        ReactiveFormsModule,
        UIModule,
        I18nModule, ɵngcc8.TranslateModule, PwcIconsModule,
        NgbTimepickerModule,
        NgxCurrencyModule,
        InputMaskModule]; }, exports: function () { return [FormsModule$1,
        ReactiveFormsModule,
        FormInputComponent,
        EmailInputComponent,
        SearchInputComponent,
        TimePickerComponent,
        DateInputComponent,
        NumericInputComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FormsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormInputComponent,
                    EmailInputComponent,
                    SearchInputComponent,
                    NumericInputComponent,
                    TimePickerComponent,
                    DateInputComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule$1,
                    ReactiveFormsModule,
                    UIModule,
                    I18nModule,
                    TranslateModule.forChild(),
                    PwcIconsModule,
                    NgbTimepickerModule,
                    NgxCurrencyModule,
                    InputMaskModule
                ],
                exports: [
                    FormsModule$1,
                    ReactiveFormsModule,
                    FormInputComponent,
                    EmailInputComponent,
                    SearchInputComponent,
                    TimePickerComponent,
                    DateInputComponent,
                    NumericInputComponent
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileDropDirective, [{
        type: Directive,
        args: [{ selector: '[ng2FileDrop]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { fileOver: [{
            type: Output
        }], onFileDrop: [{
            type: Output
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], uploader: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileSelectDirective, [{
        type: Directive,
        args: [{ selector: '[ng2FileSelect]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { onFileSelected: [{
            type: Output
        }], onChange: [{
            type: HostListener,
            args: ['change']
        }], uploader: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DirectoryDropDirective, [{
        type: Directive,
        args: [{
                selector: '[directoryDrop]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
const ɵDirectorySelectDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DirectorySelectDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DirectorySelectDirective, [{
        type: Directive,
        args: [{
                selector: '[directorySelect]'
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FileUploadModule, { declarations: function () { return [FileDropDirective,
        FileSelectDirective,
        DirectoryDropDirective,
        DirectorySelectDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FileDropDirective,
        FileSelectDirective,
        DirectoryDropDirective,
        DirectorySelectDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileUploadModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [FileDropDirective, FileSelectDirective, DirectoryDropDirective, DirectorySelectDirective],
                exports: [FileDropDirective, FileSelectDirective, DirectoryDropDirective, DirectorySelectDirective]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FiltersComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-filters',
                template: "<div class=\"card my-4\" *ngIf=\"config && values\">\n  <div class=\"card-body\">\n    <h5 class=\"card-title\">\n      <span translate>generic.filters.label</span>\n      <button class=\"btn btn-primary btn-sm btn-action-icon ml-0 btn-clear-filter\"\n              [ngbTooltip]=\"'generic.filters.clear' | translate\" (click)=\"clear.emit()\"\n              onmousedown=\"event.preventDefault();\"\n              type=\"button\">\n        <pwc-icon name=\"clear\"></pwc-icon>\n      </button>\n    </h5>\n\n    <div class=\"d-flex flex-row justify-content-between align-items-end\">\n      <!-- filters -->\n      <div class=\"d-flex flex-row flex-wrap\">\n\n        <!-- Filter field -->\n        <ng-container *ngFor=\"let field of config\">\n          <div class=\"form-group filter-item mr-4\" *ngIf=\"isVisible(field)\">\n\n            <label class=\"form-input-label no-wrap-label\" [for]=\"field.id\">\n              {{field.label | translate}}\n            </label>\n\n            <div class=\"form-group form-input-group\" *ngIf=\"!isSelect(field.type)\">\n              <input *ngIf=\"field.type === FilterType.TEXT\"\n                    type=\"text\"\n                    [id]=\"field.id\"\n                    [name]=\"field.id\"\n                    class=\"form-control form-input no-shadow input-with-border\"\n                    [(ngModel)]=\"values[field.id]\"\n                    (ngModelChange)=\"onChange()\">\n\n              <pwc-date-input *ngIf=\"field.type === FilterType.DATE\"\n                              [id]=\"field.id\"\n                              [(date)]=\"values[field.id]\"\n                              (dateChange)=\"onChange()\"></pwc-date-input>\n            </div>\n\n            <ng-select\n              *ngIf=\"isSelect(field.type)\"\n              [id]=\"field.id\"\n              [name]=\"field.id\"\n              placeholder=\"{{'generic.select-value' | translate}}\"\n              [(ngModel)]=\"values[field.id]\"\n              (change)=\"onOptionChange(field)\"\n              (remove)=\"onChange()\"\n              (clear)=\"onChange()\"\n              [searchable]=\"true\"\n              [clearable]=\"true\"\n              [multiple]=\"field.type === FilterType.MULTISELECT\"\n              class=\"no-shadow\" style=\"padding:0\">\n              <ng-option *ngFor=\"let option of field.options\" [value]=\"option.id\">\n                {{ option.label | translate }}\n              </ng-option>\n            </ng-select>\n          </div>\n        </ng-container>\n\n      </div>\n\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc6.PwcIconsLibrary }]; }, { valuesChange: [{
            type: Output
        }], clear: [{
            type: Output
        }], config: [{
            type: Input
        }], values: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FiltersModule, { declarations: function () { return [FiltersComponent]; }, imports: function () { return [CommonModule$1,
        FormsModule,
        UIModule,
        I18nModule, ɵngcc8.TranslateModule, PwcIconsModule,
        NgSelectModule]; }, exports: function () { return [FiltersComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FiltersModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FiltersComponent
                ],
                imports: [
                    CommonModule$1,
                    FormsModule,
                    UIModule,
                    I18nModule,
                    TranslateModule.forChild(),
                    PwcIconsModule,
                    NgSelectModule
                ],
                exports: [
                    FiltersComponent
                ]
            }]
    }], null, null); })();


class FilterConfig {
    constructor() {
        this.visible = true;
    }
}

/*
 * Public API Surface of @pwc/forms
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractValueAccessor, DateInputComponent, DateParserFormatterService, DirectoryDropDirective, DirectorySelectDirective, EmailInputComponent, FileDropDirective, FileItem, FileLikeObject, FileSelectDirective, FileType, FileUploadModule, FileUploader, FilterConfig, FilterType, FiltersComponent, FiltersModule, FormInputComponent, FormsModule, MakeProvider, SearchInputComponent, TimePickerComponent, ValidationUtils, NumericInputComponent as ɵa };

//# sourceMappingURL=pwc-forms.js.map